import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Switch from "react-switch";
import { ExportToCsv } from 'export-to-csv';
import Datetime from 'react-datetime';
//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  modalLoading,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import { MdDelete } from 'react-icons/md';

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { FoodContext } from "../../../../../contexts/Food";
import DataTable from "../../../../common/DataTable";

const GroupCrud = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let {
    //common
    loading,
    setLoading,
  } = useContext(SettingsContext);

  let {
    //food group
    // getFoodGroup,
    foodGroupList,
    setFoodGroupList,
    setPaginatedFoodGroup,
    foodGroupForSearch,
    setFoodGroupforSearch,
    // getFoodGroupForPOS,
    // getFoodGroupWithMenu,
    //pagination
    dataPaginating,
  } = useContext(FoodContext);

  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  const timeScheduleObj = () =>{
    return {
      schedule: 0,
      ...daysOfWeek.reduce((acc, day) => {
        acc[day] = { id:null, status: 0, from_time: null, to_time: null };
        return acc;
      }, {})
    }
  }
  const timeScheduleForObj = timeScheduleObj();
  // States hook here
  const [timeSchedule, setTimeSchedule] = useState(timeScheduleForObj);

  //new group
  let [newFoodGroup, setNewFoodGroup] = useState({
    name: "",
    translated_name: "",
    sorting:0,
    ideal_food_cost:"",
    edit: false,
    status: true,
    id: null,
    uploading: false,
  });
  //csv
  const options = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: 'Food-Group',
  };
  const csvExporter = new ExportToCsv(options);
  const [uploadCsv,setUploadCsv] = useState(null);
  const [uploadCsvModal,setUploadCsvModal] = useState(false);
  const searchInputRef = useRef(null);

  //search result
  let [searchedFoodGroup, setSearchedFoodGroup] = useState({
    list: null,
    searched: false,
  });

  //set time scheduling
  const handleTimeChange = (day, type, value) => {
    setTimeSchedule((prevData) => ({
      ...prevData,
      [day]: {
        ...prevData[day],
        [type]: type === "status" ? (value == 0 ? 1 : 0) : value,
      },
    }));
  };

  //set scheduling status
  const handleScheduleStatus = () => {
    setTimeSchedule((prevData) => ({
      ...prevData,
      schedule: timeSchedule.schedule === 0 ? 1 : 0,
    }));
  };

  //set name hook
  const handleSetNewFoodGroup = (e) => {
    setNewFoodGroup({ ...newFoodGroup, [e.target.name]: e.target.value });
  };
//set sort hook
  const handleSetNewFoodSort = (e) => {
    setNewFoodGroup({ ...newFoodGroup, [e.target.name]: e.target.value });
  };

  const checkSchedulingValidation =() =>{
    if(timeSchedule.schedule){
      let isValid = true;
      for(let i=0; i<daysOfWeek?.length; i++){
        const day = daysOfWeek[i];
        if (
          timeSchedule[day].status === 1 &&
          (!timeSchedule[day].from_time ||!timeSchedule[day].to_time)
        ) {
          isValid = false;
          break
        }
      }
      if (!isValid) {
        toast.error("Please fill all schedule time");
        return true;
      }else{
        return false;
      }
    }
  }
 
  const formatedSchedule = (schedule) =>{
    return Object.keys(schedule).reduce((acc, day) => {
      if (schedule[day].from_time && schedule[day].to_time && schedule[day].status) {
        acc[day] = {
          status: schedule[day].status,
          from_time: moment(schedule[day].from_time).format('HH:mm:ss'),
          to_time: moment(schedule[day].to_time).format('HH:mm:ss'), 
        };
      } else {
        acc[day] = schedule[day];
      }
      return acc;
    }, {});
  }

  //Save New paymentType
  const handleSaveNewFoodGroup = (e) => {
    e.preventDefault();
    if(checkSchedulingValidation()){
     return false
    }
    setNewFoodGroup({
      ...newFoodGroup,
      uploading: true,
    });
    const {schedule , ...rest} = timeSchedule;
    const formattedSchedule = formatedSchedule(rest);
    const foodGroupUrl = BASE_URL + `/settings/new-food-group`;
    let formData = new FormData();
    formData.append("name", newFoodGroup.name);
    formData.append("translated_name", newFoodGroup.translated_name);
    formData.append("sorting", newFoodGroup.sorting);
    formData.append("ideal_food_cost", newFoodGroup.ideal_food_cost);
    formData.append("schedule", schedule);
    formData.append("day_time_schedule", JSON.stringify(formattedSchedule));
    formData.append("food_group_status", newFoodGroup.status === true ? 1 : 0);

    return axios
      .post(foodGroupUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewFoodGroup({
          name: "",
          translated_name: "",
          sorting:0,
          ideal_food_cost:"",
          edit: false,
          status: true,
          id: null,
          uploading: false,
        });
        setTimeSchedule(timeScheduleForObj);
        setFoodGroupList(res.data[0]);
        setFoodGroupforSearch(res.data[1]);
        setSearchedFoodGroup({
          ...searchedFoodGroup,
          list: res.data[1],
        });
        // getFoodGroupForPOS();
        // getFoodGroupWithMenu()
        setLoading(false);
        toast.success(`${_t(t("Food group has been added"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch((error) => {
        setLoading(false);
        setNewFoodGroup({
          ...newFoodGroup,
          uploading: false,
        });
        if (error.response.data.errors) {
          if (error.response.data.errors.name) {
            error.response.data.errors.name.forEach((item) => {
              if (item === "A food group already exists with this name") {
                toast.error(
                  `${_t(t("A food group already exists with this name"))}`,
                  {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                  }
                );
              }
            });
          } else {
            toast.error(`${_t(t("Please try again"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
        }
      });
  };

  function isCSV(contents) {
    // Basic check if it's a CSV file by checking if it contains a comma
    const rows = contents.split('\n');

    // Extract the header row (assuming it's the first row)
    const headerRow = rows[0];

    // Split the header row into individual header values
    const headers = headerRow.split(',');
    return contents.includes(',') && contents.includes('\n') && (headers.length === 5);
  }

  //csv
  const handleGroupCsv = (type) =>{
    const url = BASE_URL + `/settings/get-food-items-csv/${type}`;
    return axios
      .get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        csvExporter.generateCsv(res.data);
        setLoading(false);
        
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  const handleOnChange = (e) => {
    if (e.target.files[0]) {
      const fileReader = new FileReader();
        fileReader.readAsText(e.target.files[0]);
       //fileReader.readAsBinaryString(e.target.files[0]);
       fileReader.onload = (e) => {
         const contents = e.target.result;
       
        if(isCSV(contents)){
          const startIndex = 1; // Start index
          const lines = contents.trim().split('\n').slice(startIndex);
          const parsedData = lines.map((line)=>{
            const values = line.split(',').map(value => value.replace(/["/\r\n]/g, ''));
            return {
              id : values[0],
              name : values[1],
              sorting : values[2],
              ideal_food_cost : values[3],
              food_group_status : values[4],
            }
          })
          setUploadCsv(parsedData);
        }else {  
          if (document.getElementById('uploadFile')) {
            document.getElementById('uploadFile').value = '';
          }
          setUploadCsv(null)
          setUploadCsvModal(false)
          toast.error("Please upload only group csv file", {
            position: "bottom-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          }); 
          
        } 
      
      };
     
   }; 
  }

  const handleGroupCsvSubmit = (e) => {
    e.preventDefault();
    
    const url = BASE_URL +"/settings/upload-food-items-for-csv";
    let formData = {
      items : uploadCsv
    }
    if(!uploadCsv || uploadCsv.length === 0){
      toast.error(`${_t(t("Please upload file"))}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      return false
    }
    
    setLoading(true);
    return axios
      .post(url,formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        if (document.getElementById('uploadFile')) {
          document.getElementById('uploadFile').value = '';
        }
        setUploadCsv(null);
        setUploadCsvModal(false)
        setLoading(false);
        toast.success(`${_t(t("Group file upload successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        
      })
      .catch(() => {
        setLoading(false);
        setUploadCsv(null);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  }

  //set edit true & values
  const handleSetEdit = (id) => {
    let filterFoodGroup = foodGroupForSearch.find((item) => {
      return item.id === id;
    });

    let timeObj = {
      schedule: filterFoodGroup.is_schedule
    };
    if(filterFoodGroup?.food_schedules?.length > 0){
      filterFoodGroup.food_schedules.forEach((item)=>{
        const fromTime = moment(item.from_time, 'HH:mm:ss');
        const toTime = moment(item.to_time, 'HH:mm:ss');   
        timeObj[item.day_name]= {
          id: item.id,
          from_time: fromTime,
          to_time: toTime,
          status: item.is_schedule,
        }
      })
      setTimeSchedule(timeObj)
    }else{
      setTimeSchedule(timeScheduleForObj);
    }

    setNewFoodGroup({
      ...newFoodGroup,
      name: filterFoodGroup.name,
      translated_name: filterFoodGroup?.translated_name ?? "",
      sorting:filterFoodGroup.sorting,
      ideal_food_cost: filterFoodGroup.ideal_food_cost,
      status: filterFoodGroup.food_group_status === 1 ? true : false,
      input_key: filterFoodGroup.input_key,
      id: filterFoodGroup.id,
      edit: true,
    });
  };

  const handleUpdateStatus = (item, type) =>{
    setLoading(true)
    let formData = {
      id: item?.id,
      status: type === "is_schedule" ? (item.is_schedule ? 0 : 1) : !item.food_group_status === true ? 1 : 0,
      type: type,
    }
    const foodGroupUrl = BASE_URL + `/settings/update-food-group-status`;
    return axios
    .post(foodGroupUrl, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
    .then((res) => {
      setNewFoodGroup({
        name: "",
        translated_name: "",
        sorting:0,
        ideal_food_cost:"",
        status: true,
        edit: false,
        id: null,
        uploading: false,
      });
      setFoodGroupList(res.data[0]);
      setFoodGroupforSearch(res.data[1]);
      setSearchedFoodGroup({
        ...searchedFoodGroup,
        list: res.data[1],
      });
      //  getFoodGroupForPOS();
      //  getFoodGroupWithMenu()
      setLoading(false);
      toast.success(`${_t(t("Food group has been updated"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    })
    .catch((error) => {
      setLoading(false);
      setNewFoodGroup({
        ...newFoodGroup,
        uploading: false,
      });
      if(error.response.data.status === 0){
        toast.error(`${_t(t(error.response.data.message))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return
      }
      toast.error(`${_t(t("Please try again"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    });
  }

  //update food group
  const handleUpdateFoodGroup = (e) => {
    e.preventDefault();
    if(checkSchedulingValidation()){
      return false
    }
    setNewFoodGroup({
      ...newFoodGroup,
      uploading: true,
    });
    const {schedule , ...rest} = timeSchedule;
    const formattedSchedule = formatedSchedule(rest);
    console.log(newFoodGroup, "newFoodGroup");
    
    const foodGroupUrl = BASE_URL + `/settings/update-food-group`;
    let formData = new FormData();
    formData.append("name", newFoodGroup.name);
    formData.append("translated_name", newFoodGroup.translated_name);
    formData.append("sorting", newFoodGroup.sorting);
    formData.append("ideal_food_cost", newFoodGroup.ideal_food_cost);
    formData.append("food_group_status", newFoodGroup.status === true ? 1 : 0);
    formData.append("schedule", schedule);
    formData.append("day_time_schedule", JSON.stringify(formattedSchedule));
    formData.append("id", newFoodGroup.id);

    return axios
      .post(foodGroupUrl, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setNewFoodGroup({
          name: "",
          translated_name: "",
          sorting:0,
          ideal_food_cost:"",
          status: true,
          edit: false,
          id: null,
          uploading: false,
        });
        setTimeSchedule(timeScheduleForObj);
        setFoodGroupList(res.data[0]);
        setFoodGroupforSearch(res.data[1]);
        setSearchedFoodGroup({
          ...searchedFoodGroup,
          list: res.data[1],
        });
        // getFoodGroupForPOS();
        // getFoodGroupWithMenu()
        setLoading(false);
        toast.success(`${_t(t("Food group has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        document.getElementById('close-btn').click();
      })
      .catch((error) => {
        setLoading(false);
        setNewFoodGroup({
          ...newFoodGroup,
          uploading: false,
        });
        if(error.response.data.status === 0){
          toast.error(`${_t(t(error.response.data.message))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return
        }
        if (error.response.data.errors) {
          if (error.response.data.errors.name) {
            error.response.data.errors.name.forEach((item) => {
              if (item === "A food group already exists with this name") {
                toast.error(
                  `${_t(t("A food group already exists with this name"))}`,
                  {
                    position: "bottom-center",
                    autoClose: 10000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    className: "text-center toast-notification",
                  }
                );
              }
            });
          } else {
            toast.error(`${_t(t("Please try again"))}`, {
              position: "bottom-center",
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              className: "text-center toast-notification",
            });
          }
        }
      });
  };

  //search food group here
  const handleSearch = (e) => {
    const searchInput = e.target.value.trim().toLowerCase();
    if (!searchInput) {
      return setSearchedFoodGroup({ list: null, searched: false });
    }
    const searchedList = foodGroupForSearch.filter((item) => {
      return item.name.toLowerCase().includes(searchInput);
    });
    setSearchedFoodGroup({
      list: searchedList,
      searched: true,
    });
  };

  const onClearSearch = () => {
    setSearchedFoodGroup({ list: null, searched: false });
    if (searchInputRef.current) {
      searchInputRef.current.value = "";
    }
  };

  useEffect(() => {
    if (setPaginatedFoodGroup) {
      setPaginatedFoodGroup(1);
    }
  }, []);

  const handleFetchData = (page) => {
    setPaginatedFoodGroup(page);
  };

  const handleDeleteConfirmation = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary rounded"
                onClick={() => {
                  handleDeleteFoodGroup(id);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3 rounded" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleStatus = (e) => {
    setNewFoodGroup({
      ...newFoodGroup,
      status: !newFoodGroup.status,
    });
  };

  const handleDeleteFoodGroup = (id) => {
    setLoading(true);
    const foodGroupUrl = BASE_URL + `/settings/delete-food-group/${id}`;
    return axios
      .get(foodGroupUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setFoodGroupList(res.data[0]);
        setFoodGroupforSearch(res.data[1]);
        setSearchedFoodGroup({
          ...searchedFoodGroup,
          list: res.data[1],
        });
        setLoading(false);
        toast.success(`${_t(t("Food group has been deleted successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch((error) => {
        setLoading(false);
        if(error.response.data.status === 0){
          toast.error(`${_t(t(error.response.data.message))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return
        }
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  const COLUMNS = [
    {
      label: "S/L",
      render: (item, i) =>
        searchedFoodGroup.searched
          ? i + 1
          : i +
            1 +
            ((foodGroupList?.current_page || 1) - 1) *
              (foodGroupList?.per_page || 10),
    },
    { label: "ID", render: (item) => item.id },
    { label: "Name", render: (item) => item.name },
    { label: "Sorting", render: (item) => item.sorting },
    {
      label: "Status",
      render: (item) => (
        <Switch
          checked={item?.food_group_status}
          name="status"
          onChange={() => handleUpdateStatus(item, "food_group_status")}
          height={22}
          width={44}
          offColor="#ee5253"
        />
      ),
    },
    {
      label: "Schedule",
      render: (item) => (
        <Switch
          checked={item?.is_schedule}
          name="status"
          onChange={() => handleUpdateStatus(item, "is_schedule")}
          height={22}
          width={44}
          offColor="#ee5253"
        />
      ),
    },
    {
      label: "Action",
      render: (item) => (
        <button
          className="btn btn-primary ml-2 rounded-sm del-btn"
          onClick={() => handleSetEdit(item.id)}
          data-toggle="modal"
          data-target="#addPaymentType"
        >
          <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
        </button>
      ),
    },
    {
      label: "Created",
      render: (item) =>
        item?.created_at ? (
          <Moment format="LL">{item.created_at}</Moment>
        ) : (
          ""
        ),
    },
    {
      label: "Updated",
      render: (item) =>
        item?.updated_at ? (
          <Moment format="LL">{item.updated_at}</Moment>
        ) : (
          ""
        ),
    },
  ];

  const getListData = useCallback(() => {
    if (searchedFoodGroup.searched) {
      return searchedFoodGroup.list || [];
    }
    return foodGroupList?.data || [];
  }, [searchedFoodGroup, foodGroupList]);

  return (
    <>
      <Helmet>
        <title>{_t(t("Food Groups"))}</title>
      </Helmet>

      {/*upload csv Modal*/}
      <div
        className={`modal fade ${
          uploadCsvModal !== false ? "showing" : ""
        }`}
        id="addReason"
        aria-hidden="true"
      >
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header align-items-center">
            <div className="fk-sm-card__content"></div>
            <button
              type="button"
              className="btn-close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={(e) => {
                if (document.getElementById('uploadFile')) {
                  document.getElementById('uploadFile').value = '';
                }
                setUploadCsv(null)
                setUploadCsvModal(false)
              }}
            ></button>
          </div>
          <div className="modal-body">
            {/* show form or show saving loading */}
            <div key="fragment-food-group-1">
              <form onSubmit={handleGroupCsvSubmit} autoComplete="off">
                <div>
                  <label htmlFor="name" className="form-label">
                    {_t(t("Upload File"))}{" "}
                    <small style={{ color: "red" }}>*</small>
                  </label>
                  <br/>
                  <input
                    type={"file"}
                    id="uploadFile"
                    name="uploadFile"
                    accept={".csv"}
                    onChange={handleOnChange}
                  />
                 </div>
                 <button
                 type="submit"
                 className="btn btn-primary xsm-text text-uppercase px-3 py-2 my-4 rounded"
                 >
                   {_t(t("Submit"))}
                 </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Add modal */}
      <div className="modal fade" id="addPaymentType" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <div className="fk-sm-card__content">
                <h5 className="text-capitalize fk-sm-card__title">
                  {!newFoodGroup.edit
                    ? _t(t("Add new food group"))
                    : _t(t("Update food group"))}
                </h5>
              </div>
              <button
                type="button"
                id="close-btn"
                className="btn-close"
                data-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              {/* show form or show saving loading */}
              {newFoodGroup.uploading === false ? (
                <div key="fragment-food-group-1">
                  <form
                    onSubmit={
                      !newFoodGroup.edit
                        ? handleSaveNewFoodGroup
                        : handleUpdateFoodGroup
                    }
                    autoComplete="off"
                  >
                    <div className="row">
                      <div className="col-8">
                        <label htmlFor="name" className="form-label">
                          {_t(t("Name"))}{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          name="name"
                          placeholder="e.g. Burger, Chicken"
                          value={newFoodGroup.name || ""}
                          required
                          onChange={handleSetNewFoodGroup}
                        />
                      </div>
                      <div className="col-4">
                        <label htmlFor="translated_name" className="form-label">
                          {_t(t("Translated Name"))}{" "}
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="translated_name"
                          name="translated_name"
                          value={newFoodGroup.translated_name || ""}
                          onChange={handleSetNewFoodGroup}
                        />
                      </div>
                    </div>

                    <div className="mt-3 row">
                      <div className="col-6">
                        <label htmlFor="name" className="form-label">
                          {_t(t("Sorting"))}{" "}
                          <small className="text-danger">*</small>
                        </label>
                        <input
                          type="number"
                          min="0"
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-", ".","ArrowUp", "ArrowDown"].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}
                          className="form-control"
                          id="sorting"
                          name="sorting"
                          placeholder="e.g. 0"
                          value={newFoodGroup?.sorting}
                          required
                          onChange={handleSetNewFoodSort}
                        />
                      </div>
                      <div className="col-6">
                        <label htmlFor="name" className="form-label">
                          {_t(t("Ideal Food Cost"))}
                        </label>
                        <input
                          type="number"
                          onKeyDown={(evt) =>
                            ["e", "E", "+", "-", ".","ArrowUp", "ArrowDown"].includes(evt.key) &&
                            evt.preventDefault()
                          }
                          onWheel={(e) => e.target.blur()}
                          className="form-control"
                          id="ideal_food_cost"
                          name="ideal_food_cost"
                          placeholder="e.g 10%"
                          value={newFoodGroup?.ideal_food_cost}
                          onChange={handleSetNewFoodSort}
                        />
                      </div>
                    </div>

                    <div className="row mt-3 pl-0">
                      <div className="col-6">
                        <label
                          className="form-label d-block pointer-cursor"
                          htmlFor="status"
                        >
                          {_t(t("Status"))}
                        </label>
                        <Switch
                          checked={newFoodGroup.status}
                          name="status"
                          onChange={(e) => {
                            handleStatus(e);
                          }}
                          height={22}
                          width={44}
                          offColor="#ee5253"
                          className="float-left"
                        />
                      </div>

                      <div className="col-6">
                        <label
                          className="form-label d-block pointer-cursor"
                          htmlFor="schedule"
                        >
                          {_t(t("Schedule"))}
                        </label>
                        <Switch
                          checked={timeSchedule.schedule}
                          name="schedule"
                          onChange={handleScheduleStatus}
                          height={22}
                          width={44}
                          offColor="#ee5253"
                          className="float-left"
                        />
                      </div>
                      
                    </div>

                    {timeSchedule?.schedule ? daysOfWeek && daysOfWeek.map((day) => (
                      timeSchedule[day] && (
                        <div className="row mt-3">
                          <div className="col-4 d-flex justify-content-between align-items-center">
                            {day}
                            <input
                              type="checkbox"
                              className="form-check-input pointer-cursor"
                              id="day"
                              name={day}
                              value={timeSchedule[day].status}
                              onChange={(e) => handleTimeChange(day, "status", e.target.value)}
                              checked={timeSchedule[day].status}
                            />
                          </div>
                          {
                            timeSchedule[day] && (
                              <div className="col-8 d-flex align-items-center">
                                <Datetime
                                  value={timeSchedule[day].from_time}
                                  onChange={(value) => handleTimeChange(day, 'from_time', value)}
                                  dateFormat={false}
                                  className="col"
                                  timeConstraints={{
                                    minutes: { step: 5 }, // Customize time selection steps
                                  }}
                                />
                                <span style={{ margin: '0 15px' }}>TO</span>
                                <Datetime
                                  value={timeSchedule[day].to_time}
                                  onChange={(value) => handleTimeChange(day, 'to_time', value)}
                                  dateFormat={false}
                                  className="col"
                                  timeConstraints={{
                                    minutes: { step: 5 }, // Customize time selection steps
                                  }}
                                />
                              </div>
                            )
                          }
                        </div>
                      )  
                    )) : ""}

                    <div className="mt-4">
                      <div className="row d-flex justify-content-end">
                        <div className="col-3">
                          <button
                            type="submit"
                            className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          >
                            {!newFoodGroup.edit
                              ? _t(t("Save"))
                              : _t(t("Update"))}
                          </button>
                        </div>
                        <div className="col-3">
                          <button
                            type="button"
                            className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                            data-dismiss="modal"
                          >
                            {_t(t("Close"))}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div key="fragment2">
                  <div className="text-center text-primary font-weight-bold text-uppercase">
                    {_t(t("Please wait"))}
                  </div>
                  {modalLoading(3)}
                  <div className="mt-4">
                    <div className="row d-flex justify-content-end">
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-success w-100 xsm-text text-uppercase t-width-max rounded"
                          onClick={(e) => {
                            e.preventDefault();
                          }}
                        >
                          {!newFoodGroup.edit ? _t(t("Save")) : _t(t("Update"))}
                        </button>
                      </div>
                      <div className="col-3">
                        <button
                          type="button"
                          className="btn btn-primary w-100 xsm-text text-uppercase t-width-max rounded"
                          data-dismiss="modal"
                        >
                          {_t(t("Close"))}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Add modal Ends*/}

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div className="fk-scroll--pos-table-menu" data-simplebar>
                  <div className="t-pl-15 t-pr-15">
                    {/* Loading effect */}
                    {/* {newFoodGroup.uploading === true || loading === true ? (
                      tableLoading()
                    ) : ( */}
                      <div key="fragment3">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb d-flex justify-content-between align-items-center">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {!searchedFoodGroup.searched
                                    ? _t(t("Food Group List"))
                                    : _t(t("Search Result"))}
                                </span>
                              </li>
                              <div>
                                <button title="Download group in excel" className="btn btn-success btn-sm text-uppercase sm-text mr-2 rounded" onClick={()=>handleGroupCsv("group")} >Export Csv</button>
                                <button title="Upload group in excel" className="btn btn-primary btn-sm text-uppercase sm-text mr-2 rounded" onClick={()=>setUploadCsvModal(true)}>Import Csv</button>
                              </div>
                            </ul>
                          </div>
                          <div className="col-md-6 col-lg-7">
                            <div className="row gx-3 align-items-center">
                              {/* Search group */}
                              <div className="col-md-9 t-mb-15 mb-md-0">
                                <div className="input-group">
                                  <div className="form-file">
                                    <input
                                      type="text"
                                      className="form-control border-0 form-control--light-1 rounded-left"
                                      placeholder={_t(t("Search")) + ".."}
                                      onChange={handleSearch}
                                      ref={searchInputRef}
                                    />
                                  </div>
                                  <button
                                    className="btn btn-primary border-right"
                                    type="button"
                                  >
                                    <i
                                      className="fa fa-search"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </div>

                              {/* Add group modal trigger button */}
                              <div className="col-md-3 text-md-right">
                                <button
                                  type="button"
                                  className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                                  data-toggle="modal"
                                  data-target="#addPaymentType"
                                  onClick={() => {
                                    setNewFoodGroup({
                                      ...newFoodGroup,
                                      name: "",
                                      sorting: 0,
                                      edit: false,
                                      status: true,
                                      id: null,
                                      uploading: false,
                                    });
                                    setTimeSchedule(timeScheduleForObj);
                                  }}
                                >
                                  {_t(t("add new"))}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <DataTable
                          columns={COLUMNS}
                          data={getListData()}
                          emptyText="No data available"
                          loading={loading || dataPaginating}
                          pagination={{
                            isPageLoading: loading || dataPaginating,
                            isPagination: !searchedFoodGroup.searched,
                            pageCount: foodGroupList?.last_page,
                            currentPage: foodGroupList?.current_page,
                            from: foodGroupList?.from,
                            to: searchedFoodGroup.searched
                              ? foodGroupForSearch?.length
                              : foodGroupList?.to,
                            total: foodGroupList?.total,
                          }}
                          handleFetchData={handleFetchData}
                          searchPayload={{
                            isSearched: searchedFoodGroup.searched,
                            onClearSearch,
                          }}
                        />
                      </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default GroupCrud;
